import log from 'loglevel';

/**
 * Wraps local storage functionality and will log a warning if local storage can not be accessed for any reason.
 */
export class LocalStorageManager {
  static setItem(key: string, value: any): void {
    if (localStorage) {
      localStorage.setItem(key, value);
    } else {
      log.warn(`Could not find localStorage to write to.`);
    }
  }

  static getItem(key: string): string | null {
    if(localStorage) {
      return localStorage.getItem(key);
    } else {
      log.warn(`Could not find localStorage to read from.`);
      return null;
    }
  }
}
